import React from 'react'
import { Link } from 'react-router-dom'
import { Logo } from '../../components/Layout'

export default (props) => {
  return (
    <div className='not-found'>
      <div className='not-found__wrapper'>
        <div className='not-found__logo'>
          <Logo width='64' />
        </div>
        <h2 className='not-found__text'>Page not found</h2>
        <Link to='/'>Home page</Link>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/NotFound/NotFound.jsx